const AgendaData27 = [
  {
    title: "Monday, June 7",
    events: [
      {
        time: "7:30 am - 8:30 am",
        title: "Breakfast",
      },
      {
        time: "8:30 am - 10:00 am",
        title: "Be the Coffee Bean",
        isKeynote: true,
        sessions: [
          {
            speakers: [
              {
                name: "Damon West",
                company: "Best-Selling Author and Speaker",
              },
            ],
            description:
              "Hear about how a former college quarterback, sentenced to life in prison, transformed his life. Damon West learned how to change the environment around him and emerged - after more than seven years in prison - a changed man, sparked by a life-changing conversation inside prison.",
          },
        ],
      },
      {
        time: "10:00 am - 10:15 am",
        title: "Morning Break",
      },
      {
        time: "10:15 am - 11:45 am",
        title:
          "From Benchmark to Business Impact: Essential Insights and Salary Trends for Compensation Leaders",
        sessions: [
          {
            speakers: [
              {
                name: "Christie Summervill",
                company: "BalancedComp",
              },
            ],
            description:
              "Christie Summervill, CEO and Principal of BalancedComp, LLC, brings over 25 years of compensation consulting experience to help financial institutions design effective salary structures, incentives, performance management programs and CEO compensation plans. In this session, she will explore the latest shifts in pay strategies that are quietly revolutionizing the banking world. We'll break down how to stay competitive without breaking the budget (or your CFO's heart). Expect practical insights on aligning pay with performance, keeping regulators happy, and yes, finally answering that eternal question: “Are we paying enough… or just enough to lose them slowly?” You'll leave armed with data, strategies, and just enough sass to defend your next comp plan with a straight face and a strong case.",
          },
        ],
      },
      {
        time: "11:45 am - 1:30 pm",
        title: "Lunch",
      },
      {
        time: "1:30 pm - 2:30 pm",
        sessions: [
          {
            count: "1",
            title: "The Truth Problem in Compensation Philosophy",
            speakers: [
              {
                name: "Philippe Asselin",
                company: "BalancedComp",
              },
            ],
            description:
              "This presentation explores why compensation philosophies in banks and credit unions often fail to drive engagement, trust, and long-term sustainability when they lose alignment with objective market data, measurable performance standards, organizational culture, and financial realities. Attendees will learn how transparency, communication, adaptability, operational efficiency, and continuously evolving variable pay strategies can strengthen total rewards programs while supporting retention, performance, and institutional sustainability. Designed for executive and HR leaders, this session provides practical frameworks and strategic insights for building compensation philosophies that remain credible, competitive, and sustainable in rapidly changing labor and economic environments.<hr class='my-4'>",
          },
          {
            count: "2",
            title:
              "Executive Compensation & Succession in the Retirement Wave: Aligning Pay with Risk, Performance & Legacy",
            speakers: [
              {
                name: "William Flynt Gallagher",
                company: "Newcleus",
              },
            ],
            description:
              "Looming leadership retirements in community banks and credit unions demand proactive planning. Boards are refining pay mixes (fixed vs. variable, long-term incentives) to retain key talent while tying them to performance-based outcomes and succession goals. Key angles include designing deferred compensation, long-term incentives, employment agreements, and change-in-control considerations. The impact: identifying the true cost of replacing key personnel, and educating directors and professionals on best practices to retain critical knowledge while transitioning to new leadership teams.<hr class='my-4'>",
          },
          {
            count: "3",
            title: "The Peanut Butter Spread",
            speakers: [
              {
                name: "Deborah Reid",
                company: "BalancedComp",
              },
            ],
            description:
              "Companies are using the Peanut Butter Spread for merit increases, which can lead to detrimental consequences. Why are companies adopting this pay practice, the potential pitfalls and ideas on how to avoid negative results with limited resources.<hr class='my-4'>",
          },
          {
            count: "4",
            title: "Getting Supervisors to Deliver: An HR Leaders Panel",
            speakers: [
              {
                name: "Crystal Hughes",
                company: "BalancedComp",
              },
              {
                name: "Coming Soon",
              },
              {
                name: "Coming Soon",
              },
            ],
            description:
              "This panel brings together experienced HR executives to openly share their real-world struggles and hard-earned successes in getting supervisors and managers to deliver effective, meaningful performance reviews. Rather than focusing on templates or theory, the discussion dives into the practical challenges—resistance, lack of skills, time constraints, and discomfort—and the proven strategies these leaders used to drive real behavior change across their organizations. Attendees will hear candid stories, actionable tactics, and interactive Q&A, making this a highly practical session designed for HR professionals who want to move beyond frustration to measurable improvement in performance management.",
          },
        ],
      },
      {
        time: "2:30 pm - 3:00 pm",
        title: "Afternoon Break",
      },
      {
        time: "3:00 pm - 4:45 pm",

        title: "HR Roundtables",
        titleFirst: "true",
        sessions: [
          {
            speakers: [
              {
                name: "Coming Soon",
              },
              {
                name: "Coming Soon",
              },
              {
                name: "Coming Soon",
              },
              {
                name: "Coming Soon",
              },
            ],
          },
        ],
      },
      {
        time: "5:15 pm - 7:00 pm",
        title: "Networking Event",
      },
    ],
  },
  {
    title: "Tuesday, June 8",
    events: [
      {
        time: "7:30 am - 8:30 am",
        title: "Breakfast",
      },
      {
        time: "8:30 am - 10:00 am",
        title: "U.S. Economic Outlook & Its Impact on Financial Institutions",
        isKeynote: true,
        sessions: [
          {
            speakers: [
              {
                name: "Steven Rick",
                company: "TruStage",
              },
            ],
            description:
              "Steve Rick will discuss how the global economy, the overall financial sector and the labor market will affect the U.S. economy, U.S. interest rates, and ultimately financial institutions' balance sheets and earnings performances. Rick will also analyze and establish standards against which your financial institution's own performance can be measured. He will also identify trends of savings and loan activity, and weigh the influence of future economic events on growth patterns out into 2028.",
          },
        ],
      },
      {
        time: "10:00 am - 10:15 am",
        title: "Morning Break",
      },
      {
        time: "10:15 am - 11:45 am",
        title:
          "From Regulation to Retirement: The CLARITY Act's Impact on 401(k) Crypto Investing",
        sessions: [
          {
            speakers: [
              {
                name: "Dan Wheeler",
                company: "360 Trader",
              },
            ],
            description:
              "Crypto in 401(k)s Unlocked: The CLARITY + DOL Playbook for Banks & Credit Unions (Live Crypto Giveaway). In this high-energy 90-minute session, crypto expert Dan Wheeler reveals how the Digital Asset Market Clarity (CLARITY) Act's framework for classifying digital assets as commodities under CFTC oversight—combined with the Department of Labor's 2025 rescission of its restrictive 2022 guidance—has finally given plan sponsors the regulatory certainty to evaluate and add Bitcoin, Ether, and other crypto options to 401(k) menus. HR leaders from banks and credit unions will walk away with a practical, fiduciary-focused roadmap tailored to their institutions' employee benefits and client offerings. Stay for our exclusive live Crypto Giveaway open only to attendees!",
          },
        ],
      },
      {
        time: "11:45 am - 1:30 pm",
        title: "Lunch",
      },
      {
        time: "1:30 pm - 2:30 pm",
        sessions: [
          {
            count: "1",
            title: "The Truth Problem in Compensation Philosophy",
            speakers: [
              {
                name: "Philippe Asselin",
                company: "BalancedComp",
              },
            ],
            description:
              "This presentation explores why compensation philosophies in banks and credit unions often fail to drive engagement, trust, and long-term sustainability when they lose alignment with objective market data, measurable performance standards, organizational culture, and financial realities. Attendees will learn how transparency, communication, adaptability, operational efficiency, and continuously evolving variable pay strategies can strengthen total rewards programs while supporting retention, performance, and institutional sustainability. Designed for executive and HR leaders, this session provides practical frameworks and strategic insights for building compensation philosophies that remain credible, competitive, and sustainable in rapidly changing labor and economic environments.<hr class='my-4'>",
          },
          {
            count: "2",
            title: "The Peanut Butter Spread",
            speakers: [
              {
                name: "Deborah Reid",
                company: "BalancedComp",
              },
            ],
            description:
              "Companies are using the Peanut Butter Spread for merit increases, which can lead to detrimental consequences. Why are companies adopting this pay practice, the potential pitfalls and ideas on how to avoid negative results with limited resources.<hr class='my-4'>",
          },
          {
            count: "3",
            title: "World at Work",
            speakers: [
              {
                name: "Coming Soon",
              },
            ],
            description: "Coming Soon<hr class='my-4'>",
          },
          {
            count: "4",
            title: "Doing Remote Work Right",
            speakers: [
              {
                name: "Sanjyot Mohile",
                company: "Alloya Corporation",
              },
            ],
            description:
              "While many organizations are doubling down on return-to-office mandates, Alloya Corporate Federal Credit Union boldly chose a different path, and the results have been transformative. What began as a necessary response has evolved into a powerful competitive advantage. In this compelling session, you'll discover how Alloya's intentional remote-first strategy has delivered exceptional outcomes for both the organization and its people: dramatically reduced costs, access to a dramatically expanded national talent pool, and dramatically higher employee engagement. You'll learn how Alloya masterfully combines genuine flexibility with a strong, values-driven culture to successfully deliver large-scale strategic projects, sustain industry-leading customer service scores, strengthen the bottom line, and achieve some of the highest Gallup engagement results in the credit union's history. If you've ever questioned whether remote work can produce real, measurable business impact rather than just short-term convenience, this session offers clear, inspiring proof. Through an honest, data-rich case study, Sanjyot will demonstrate exactly how Alloya built a thriving, high-performance remote organization that outperforms traditional models.",
          },
        ],
      },
      {
        time: "2:30 pm - 3:00 pm",
        title: "Afternoon Break",
      },
      {
        time: "3:00 pm - 4:45 pm",
        title: "HR Roundtables",
        titleFirst: true,
        sessions: [
          {
            speakers: [
              {
                name: "Coming Soon",
              },
              {
                name: "Coming Soon",
              },
              {
                name: "Coming Soon",
              },
              {
                name: "Coming Soon",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Wednesday, June 9",
    events: [
      {
        time: "7:30 am - 8:30 am",
        title: "Breakfast",
      },
      {
        time: "8:30 am - 10:00 am",
        title:
          "Honor: The Price, Value, and Impact of Establishing and Operating in Honor-Driven Environments",
        sessions: [
          {
            speakers: [
              {
                name: "Marios Ellinas",
                company: "Sownlend Consulting LLC",
              },
            ],
            description:
              "Honor, a high level of respect we may choose to demonstrate towards those around us, elevates and empowers them, facilitating optimal conditions for individuals and organizations to thrive.",
          },
        ],
      },
      {
        time: "10:00 am - 10:15 am",
        title: "Morning Break",
      },
      {
        time: "10:15 am - 11:45 am",
        title:
          "How to Say Anything to Anyone: Setting Expectations for Powerful Working Relationships",
        sessions: [
          {
            speakers: [
              {
                name: "Shari Harley",
                company: "Candid Culture",
              },
            ],
            description: `You have a request for one of your co-workers but don't know how to say it, so you don't say anything. A project you worked on for six months has become a black hole. There is no information about the status. You're frustrated, but you don't say anything. Two employees aren't working well together. It's impacting the atmosphere in the office. You don't know what to say, so you don't say anything. Speaking up when we are frustrated is hard and, as a result, most of us don't. Instead, either we tell other people (aka gossip) or we say nothing, and relationships become strained. You can say anything to anyone and have it be easy. You just need to lay the groundwork to do so, and most of us don't.`,
          },
        ],
      },
      {
        time: "11:45 am - 12:00 pm",
        title: "Closing Remarks",
        sessions: [
          {
            speakers: [
              {
                name: "Christie Summervill",
                company: "BalancedComp",
              },
            ],
          },
        ],
      },
      {
        time: "12:00 pm - 1:00 pm",
        title: "Lunch (Workshop Participants Only)",
      },

      {
        time: "1:00 pm - 3:00 pm",
        title:
          "Educating Stakeholders at Every Level: How to Successfully Roll Out Your Salary Administration Program",
        isWorkshop: true,
        sessions: [
          {
            speakers: [
              {
                name: "Christie Summervill",
                company: "BalancedComp",
              },
              {
                name: "Jeff Miller",
                company: "BalancedComp",
              },
            ],
            description:
              "In response to overwhelming demand from peers and past attendees, we are excited to offer this highly requested 3-hour post-conference interactive workshop, including lunch, cohosted by industry veteran, CEO and Compensation Expert Christie Summervill and Compensation Consultant Jeff Miller. Join us for this practical, hands-on session and discover how to confidently implement an effective salary administration program that drives manager buy-in, minimizes pushback, and aligns compensation practices with your organization's goals. You'll explore proven strategies for communicating the program clearly, training leaders at every level, and ensuring consistent, equitable application—transforming compensation from a frequent pain point into a powerful driver of performance and retention.",
          },
        ],
      },
    ],
  },
];

export default AgendaData27;
